export const paginate = (hotels, pageSize, pageNumber) => {
  const start = (pageNumber - 1) * pageSize;
  const end = pageNumber * pageSize;
  return hotels.slice(start, end);
};
